import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fr, en } from 'vuetify/locale'

import { ULAVAL_RED_THEME, ULAVAL_BLUE_THEME, ULAVAL_PURPLE_THEME } from '@common/theme/LightTheme'
import { ULAVAL_DARK_RED_THEME, ULAVAL_DARK_BLUE_THEME, ULAVAL_DARK_PURPLE_THEME } from '@common/theme/DarkTheme'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'ULAVAL_BLUE_THEME',
    themes: {
      ULAVAL_RED_THEME,
      ULAVAL_BLUE_THEME,
      ULAVAL_PURPLE_THEME,
      ULAVAL_DARK_RED_THEME,
      ULAVAL_DARK_BLUE_THEME,
      ULAVAL_DARK_PURPLE_THEME
    }
  },
  locale: {
    locale: 'fr',
    fallback: 'en',
    messages: { fr, en }
  },
  defaultLocale: 'fr'
})
console.log('Locale de Vuetify:', vuetify.locale)
export default vuetify

